import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
  AdminOrganizationAttrsValues,
  AdminOrganizationAttrs,
} from 'src/app/admin/models/organization.model';
import {
  AdminOrganizationAttrsApiError,
  AdminOrganizationAttrsApiErrorTypes,
} from './admin-organization-attrs.errors';

const BASE_URL = `${environment.apiConfig.url}/admin/organization-attrs`;

@Injectable()
export class AdminOrganizationAttrsService {
  constructor(private http: HttpClient) {}

  getAdminStockDPs(): Observable<string[]> {
    const url = `${BASE_URL}/stocks`;

    return this.http.get<string[]>(url);
  }

  addAdminOrganizationAttrs(
    organizationId: number,
    values: AdminOrganizationAttrsValues,
  ): Observable<AdminOrganizationAttrs> {
    const url = BASE_URL;
    const data = {
      organizationId,
      values,
    };

    return this.http
      .post<AdminOrganizationAttrs>(url, data)
      .pipe(
        catchError((err) =>
          throwError(
            new AdminOrganizationAttrsApiError(
              AdminOrganizationAttrsApiErrorTypes.AdminCreateOrganizationAttrsError,
              err,
            ),
          ),
        ),
      );
  }

  getAdminOrganizationAttrs(organizationId: number): Observable<AdminOrganizationAttrs> {
    const url = `${BASE_URL}/${organizationId}`;

    return this.http
      .get<AdminOrganizationAttrs>(url)
      .pipe(
        catchError((err) =>
          throwError(
            new AdminOrganizationAttrsApiError(
              AdminOrganizationAttrsApiErrorTypes.AdminOrganizationAttrsNotFoundError,
              err,
            ),
          ),
        ),
      );
  }

  deleteAdminOrganizationAttrs(organizationId: number): Observable<any> {
    const url = `${BASE_URL}/${organizationId}`;

    return this.http
      .delete(url)
      .pipe(
        catchError((err) =>
          throwError(
            new AdminOrganizationAttrsApiError(
              AdminOrganizationAttrsApiErrorTypes.AdminDeleteOrganizationAttrsError,
              err,
            ),
          ),
        ),
      );
  }
}
